// src/pages/ViewProjectTeam.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProjectTeamService from "../services/ProjectTeamService";
import Breadcrumb from "../components/Breadcrumb";
import StorageService from "../services/StorageService";

export default function ViewProjectTeam() {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(null); //  RADIO (single select)

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const companyId = StorageService.activeCompany()?.companyId;
      const res = await ProjectTeamService.getAll(1, 1000, "", "", null, null, companyId);
      const rows = res?.data ?? res ?? [];
      const employees = [
        { id: 1, name: "Emp1" },
        { id: 2, name: "Emp2" },
      ];

      const updatedData = rows.map((item) => {
        const emp = employees.find((e) => e.id === item.employeeId);
        return {
          ...item,
          employeeName: emp ? emp.name : "N/A",
          isActive:
            item.status === "Active" ||
            item.isActive === 1 ||
            item.isActive === true,
        };
      });
      setList(updatedData);
    } catch (err) {
      console.error("Fetch Project Team failed:", err);
      setList([]);
      alert(err?.response?.data?.message || "Failed to fetch Project Team");
    }
  };

  // 🔹 RADIO SELECT
  const handleSelect = (id) => {
    setSelected(id);
  };

  const handleModify = () => {
    if (!selected) {
      alert("Please select one record to modify");
      return;
    }
    const item = list.find((x) => x.id === selected);
    localStorage.setItem("editProjectTeam", JSON.stringify(item));
    navigate("/cpnl/projectteam/add");
  };

  const toggleStatus = async (id, currentStatus) => {
    const newStatusText = currentStatus ? "Inactive" : "Active";
    if (
      !window.confirm(
        `Are you sure you want to set status to ${newStatusText}?`
      )
    )
      return;

    try {
      const res = await ProjectTeamService.toggleStatus(id);

      if (res && res.status === false) {
        alert(res.message || "Failed to update status");
        return;
      }

      setList((prev) =>
        prev.map((x) =>
          x.id === id ? { ...x, isActive: !currentStatus } : x
        )
      );

      if (res?.message) alert(res.message);
    } catch (error) {
      console.error("Toggle failed", error);
      alert(error?.response?.data?.message || "Failed to update status");
    }
  };

  return (
    <>
      <Breadcrumb pageTitle="Project Team" secondTitle="Masters" />
      <div className="card p-3 bg-white shadow-sm">
        <div className="mb-2">
          <button
            className="btn btn-success me-2"
            onClick={() => {
              localStorage.removeItem("editProjectTeam");
              navigate("/cpnl/projectteam/add");
            }}
          >
            <i className="ti ti-plus me-1"></i>Add
          </button>
          <button className="btn btn-warning" onClick={handleModify}>
            <i className="ti ti-pencil me-1"></i> Modify
          </button>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Select</th>
                <th>Project</th>
                <th>Employee</th>
                <th>Role</th>
                <th>Assigned Date</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {list.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center text-muted">
                    No records
                  </td>
                </tr>
              ) : (
                list.map((x) => (
                  <tr key={x.id}>
                    <td>
                      <input
                        type="radio"
                        name="projectTeamSelect"
                        checked={selected === x.id}
                        onChange={() => handleSelect(x.id)}
                      />
                    </td>
                    <td>{x.projectName}</td>
                    <td>{x.employeeName}</td>
                    <td>{x.roleName}</td>
                    <td>{x.assignedDate?.slice(0, 10) ?? "-"}</td>
                    <td>
                      <span
                        className={`badge ${
                          x.isActive ? "bg-success" : "bg-secondary"
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleStatus(x.id, x.isActive)}
                      >
                        {x.isActive ? "Active" : "Inactive"}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
